var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 196,
    viewBox: "0 0 214 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2589_2694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 60H165C169.418 60 173 63.5817 173 68V157H1V60Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 76,
    width: 111,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 86,
    width: 111,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 96,
    width: 76,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 106,
    width: 57,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 116,
    width: 76,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2589_2694)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_2589_2694",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 157H173V186C173 190.418 169.418 194 165 194H9C4.58173 194 1 190.418 1 186V157Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1 157H173V186C173 190.418 169.418 194 165 194H9C4.58173 194 1 190.418 1 186V157Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 156H173V158H1V156ZM173 194H1H173ZM1 194V157V194ZM173 157V194V157Z",
    fill: "#7E8392",
    fillOpacity: 0.1,
    mask: "url(#path-7-inside-1_2589_2694)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9531 176.818H54.7324V175.652H56.9531C57.3398 175.652 57.6523 175.59 57.8906 175.465C58.1289 175.34 58.3027 175.168 58.4121 174.949C58.5254 174.727 58.582 174.473 58.582 174.188C58.582 173.918 58.5254 173.666 58.4121 173.432C58.3027 173.193 58.1289 173.002 57.8906 172.857C57.6523 172.713 57.3398 172.641 56.9531 172.641H55.1836V180H53.7129V171.469H56.9531C57.6133 171.469 58.1738 171.586 58.6348 171.82C59.0996 172.051 59.4531 172.371 59.6953 172.781C59.9375 173.188 60.0586 173.652 60.0586 174.176C60.0586 174.727 59.9375 175.199 59.6953 175.594C59.4531 175.988 59.0996 176.291 58.6348 176.502C58.1738 176.713 57.6133 176.818 56.9531 176.818ZM62.6543 174.867V180H61.2422V173.66H62.5898L62.6543 174.867ZM64.5938 173.619L64.582 174.932C64.4961 174.916 64.4023 174.904 64.3008 174.896C64.2031 174.889 64.1055 174.885 64.0078 174.885C63.7656 174.885 63.5527 174.92 63.3691 174.99C63.1855 175.057 63.0312 175.154 62.9062 175.283C62.7852 175.408 62.6914 175.561 62.625 175.74C62.5586 175.92 62.5195 176.121 62.5078 176.344L62.1855 176.367C62.1855 175.969 62.2246 175.6 62.3027 175.26C62.3809 174.92 62.498 174.621 62.6543 174.363C62.8145 174.105 63.0137 173.904 63.252 173.76C63.4941 173.615 63.7734 173.543 64.0898 173.543C64.1758 173.543 64.2676 173.551 64.3652 173.566C64.4668 173.582 64.543 173.6 64.5938 173.619ZM68.1562 180.117C67.6875 180.117 67.2637 180.041 66.8848 179.889C66.5098 179.732 66.1895 179.516 65.9238 179.238C65.6621 178.961 65.4609 178.635 65.3203 178.26C65.1797 177.885 65.1094 177.48 65.1094 177.047V176.812C65.1094 176.316 65.1816 175.867 65.3262 175.465C65.4707 175.062 65.6719 174.719 65.9297 174.434C66.1875 174.145 66.4922 173.924 66.8438 173.771C67.1953 173.619 67.5762 173.543 67.9863 173.543C68.4395 173.543 68.8359 173.619 69.1758 173.771C69.5156 173.924 69.7969 174.139 70.0195 174.416C70.2461 174.689 70.4141 175.016 70.5234 175.395C70.6367 175.773 70.6934 176.191 70.6934 176.648V177.252H65.7949V176.238H69.2988V176.127C69.291 175.873 69.2402 175.635 69.1465 175.412C69.0566 175.189 68.918 175.01 68.7305 174.873C68.543 174.736 68.293 174.668 67.9805 174.668C67.7461 174.668 67.5371 174.719 67.3535 174.82C67.1738 174.918 67.0234 175.061 66.9023 175.248C66.7812 175.436 66.6875 175.662 66.6211 175.928C66.5586 176.189 66.5273 176.484 66.5273 176.812V177.047C66.5273 177.324 66.5645 177.582 66.6387 177.82C66.7168 178.055 66.8301 178.26 66.9785 178.436C67.127 178.611 67.3066 178.75 67.5176 178.852C67.7285 178.949 67.9688 178.998 68.2383 178.998C68.5781 178.998 68.8809 178.93 69.1465 178.793C69.4121 178.656 69.6426 178.463 69.8379 178.213L70.582 178.934C70.4453 179.133 70.2676 179.324 70.0488 179.508C69.8301 179.688 69.5625 179.834 69.2461 179.947C68.9336 180.061 68.5703 180.117 68.1562 180.117ZM73.7754 178.881L75.3281 173.66H76.793L74.5898 180H73.6758L73.7754 178.881ZM72.5859 173.66L74.168 178.904L74.2441 180H73.3301L71.1152 173.66H72.5859ZM79.1777 173.66V180H77.7598V173.66H79.1777ZM77.666 171.996C77.666 171.781 77.7363 171.604 77.877 171.463C78.0215 171.318 78.2207 171.246 78.4746 171.246C78.7246 171.246 78.9219 171.318 79.0664 171.463C79.2109 171.604 79.2832 171.781 79.2832 171.996C79.2832 172.207 79.2109 172.383 79.0664 172.523C78.9219 172.664 78.7246 172.734 78.4746 172.734C78.2207 172.734 78.0215 172.664 77.877 172.523C77.7363 172.383 77.666 172.207 77.666 171.996ZM83.5195 180.117C83.0508 180.117 82.627 180.041 82.248 179.889C81.873 179.732 81.5527 179.516 81.2871 179.238C81.0254 178.961 80.8242 178.635 80.6836 178.26C80.543 177.885 80.4727 177.48 80.4727 177.047V176.812C80.4727 176.316 80.5449 175.867 80.6895 175.465C80.834 175.062 81.0352 174.719 81.293 174.434C81.5508 174.145 81.8555 173.924 82.207 173.771C82.5586 173.619 82.9395 173.543 83.3496 173.543C83.8027 173.543 84.1992 173.619 84.5391 173.771C84.8789 173.924 85.1602 174.139 85.3828 174.416C85.6094 174.689 85.7773 175.016 85.8867 175.395C86 175.773 86.0566 176.191 86.0566 176.648V177.252H81.1582V176.238H84.6621V176.127C84.6543 175.873 84.6035 175.635 84.5098 175.412C84.4199 175.189 84.2812 175.01 84.0938 174.873C83.9062 174.736 83.6562 174.668 83.3438 174.668C83.1094 174.668 82.9004 174.719 82.7168 174.82C82.5371 174.918 82.3867 175.061 82.2656 175.248C82.1445 175.436 82.0508 175.662 81.9844 175.928C81.9219 176.189 81.8906 176.484 81.8906 176.812V177.047C81.8906 177.324 81.9277 177.582 82.002 177.82C82.0801 178.055 82.1934 178.26 82.3418 178.436C82.4902 178.611 82.6699 178.75 82.8809 178.852C83.0918 178.949 83.332 178.998 83.6016 178.998C83.9414 178.998 84.2441 178.93 84.5098 178.793C84.7754 178.656 85.0059 178.463 85.2012 178.213L85.9453 178.934C85.8086 179.133 85.6309 179.324 85.4121 179.508C85.1934 179.688 84.9258 179.834 84.6094 179.947C84.2969 180.061 83.9336 180.117 83.5195 180.117ZM88.8809 178.594L90.3457 173.66H91.248L91.002 175.137L89.5254 180H88.7168L88.8809 178.594ZM88.0195 173.66L89.1621 178.617L89.2559 180H88.3535L86.6367 173.66H88.0195ZM92.6191 178.559L93.7266 173.66H95.1035L93.3926 180H92.4902L92.6191 178.559ZM91.4004 173.66L92.8477 178.535L93.0293 180H92.2207L90.7266 175.131L90.4805 173.66H91.4004ZM100.963 180H99.5508V173.092C99.5508 172.611 99.6445 172.207 99.832 171.879C100.023 171.551 100.299 171.303 100.658 171.135C101.018 170.963 101.451 170.877 101.959 170.877C102.162 170.877 102.416 170.891 102.721 170.918C103.029 170.945 103.35 170.98 103.682 171.023C104.014 171.062 104.318 171.104 104.596 171.146L103.986 172.23C103.623 172.164 103.285 172.113 102.973 172.078C102.66 172.039 102.377 172.02 102.123 172.02C101.873 172.02 101.662 172.062 101.49 172.148C101.318 172.23 101.188 172.352 101.098 172.512C101.008 172.668 100.963 172.861 100.963 173.092V180ZM103.184 180V171.146H104.596V180H103.184ZM102.27 173.66V174.691H98.5781V173.66H102.27ZM105.896 176.9V176.766C105.896 176.309 105.963 175.885 106.096 175.494C106.229 175.1 106.42 174.758 106.67 174.469C106.924 174.176 107.232 173.949 107.596 173.789C107.963 173.625 108.377 173.543 108.838 173.543C109.303 173.543 109.717 173.625 110.08 173.789C110.447 173.949 110.758 174.176 111.012 174.469C111.266 174.758 111.459 175.1 111.592 175.494C111.725 175.885 111.791 176.309 111.791 176.766V176.9C111.791 177.357 111.725 177.781 111.592 178.172C111.459 178.562 111.266 178.904 111.012 179.197C110.758 179.486 110.449 179.713 110.086 179.877C109.723 180.037 109.311 180.117 108.85 180.117C108.385 180.117 107.969 180.037 107.602 179.877C107.238 179.713 106.93 179.486 106.676 179.197C106.422 178.904 106.229 178.562 106.096 178.172C105.963 177.781 105.896 177.357 105.896 176.9ZM107.309 176.766V176.9C107.309 177.186 107.338 177.455 107.396 177.709C107.455 177.963 107.547 178.186 107.672 178.377C107.797 178.568 107.957 178.719 108.152 178.828C108.348 178.938 108.58 178.992 108.85 178.992C109.111 178.992 109.338 178.938 109.529 178.828C109.725 178.719 109.885 178.568 110.01 178.377C110.135 178.186 110.227 177.963 110.285 177.709C110.348 177.455 110.379 177.186 110.379 176.9V176.766C110.379 176.484 110.348 176.219 110.285 175.969C110.227 175.715 110.133 175.49 110.004 175.295C109.879 175.1 109.719 174.947 109.523 174.838C109.332 174.725 109.104 174.668 108.838 174.668C108.572 174.668 108.342 174.725 108.146 174.838C107.955 174.947 107.797 175.1 107.672 175.295C107.547 175.49 107.455 175.715 107.396 175.969C107.338 176.219 107.309 176.484 107.309 176.766ZM114.697 178.594L116.162 173.66H117.064L116.818 175.137L115.342 180H114.533L114.697 178.594ZM113.836 173.66L114.979 178.617L115.072 180H114.17L112.453 173.66H113.836ZM118.436 178.559L119.543 173.66H120.92L119.209 180H118.307L118.436 178.559ZM117.217 173.66L118.664 178.535L118.846 180H118.037L116.543 175.131L116.297 173.66H117.217Z",
    fill: "#3497F9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2589_2694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 8C70 3.58172 73.5817 0 78 0H213V32C213 36.4183 209.418 40 205 40H78C73.5817 40 70 36.4183 70 32V8Z",
    fill: "#D9FDD3",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 13,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 23,
    width: 91,
    height: 5,
    rx: 2.5,
    fill: "#C3C3C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2589_2694",
    x: 0,
    y: 60,
    width: 174,
    height: 99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2589_2694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2589_2694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2589_2694",
    x: 0,
    y: 157,
    width: 174,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2589_2694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2589_2694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2589_2694",
    x: 69,
    y: 0,
    width: 145,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2589_2694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2589_2694",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatScreen);
export default __webpack_public_path__ + "static/media/chatScreen.58244dc9519765ac9cfc83786e7a28bc.svg";
export { ForwardRef as ReactComponent };